module.exports = __webpack_public_path__ + "img/fleetware_logo_3.9576810f.png";